module.exports = __webpack_public_path__ + "ec6bb9631ba25d59fa41880017173951.png";